import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";
import { defaultConfig } from "../config/tom-select";

export default class extends Controller {
  static values = {
    allowCreate: Boolean,
    preventDelete: Boolean,
    disableSearch: Boolean,
    allowClearOptions: Boolean,
    allowEmptyOption: Boolean,
  };

  connect() {
    if (this.element.tomselect) {
      return;
    }

    new TomSelect(this.element, this.config());
  }

  disconnect() {
    if (!this.element.tomselect) {
      return;
    }

    // The HTML has been replaced, so tom-select must restore the current
    // options on destroy. Its cached tabIndex is kept: by now the element
    // carries the -1 tom-select set on it, not the original value.
    this.element.tomselect.revertSettings.innerHTML = this.element.innerHTML;

    this.element.tomselect.destroy();
  }

  addOptgroupLabel = function () {
    if (Object.keys(this.optgroups).length == 0) {
      return;
    }
    Object.keys(this.options).forEach((key) => {
      this.updateOption(this.options[key].value, {
        ...this.options[key],
        optgroupLabel: this.optgroups[this.options[key].optgroup].label,
      });
    });
  };

  renderItem = (data, escape) => {
    if (!data.optgroupLabel) {
      return "<div>" + escape(data.text) + "</div>";
    }

    return (
      "<div><strong>" +
      escape(data.optgroupLabel) +
      "</strong>: " +
      escape(data.text) +
      "</div>"
    );
  };

  config() {
    let config = Object.assign({}, defaultConfig, {
      create: this.allowCreateValue,
      maxItems: 1,
      onItemAdd: () => this.element.tomselect.blur(),
      onDelete: () => {
        return !this.preventDeleteValue;
      },
      onInitialize: this.addOptgroupLabel,
      render: Object.assign({}, defaultConfig.render, {
        item: this.renderItem,
      }),
      allowEmptyOption: this.allowEmptyOptionValue,
    });

    if (this.disableSearchValue) {
      config.controlInput = null;
    }

    if (this.allowCreateValue) {
      config.render.no_results = null;
    }

    config.searchField = ["text", "optgroupLabel"];

    this.addPlugins(config);

    return config;
  }

  addPlugins(config) {
    if (!this.hasAllowClearOptionsValue) {
      return;
    }

    if (this.allowClearOptionsValue == true) {
      config.plugins = {
        clear_button: {
          title: "Ta bort",
          html: (data) =>
            `<i class="fa fa-close clear-button" title="${data.title}"></i>`,
        },
      };
      return;
    }

    config.plugins = ["no_backspace_delete"];
  }
}
